import React, {Component} from 'react';
import {Button} from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
import CircularProgress from '@material-ui/core/CircularProgress';
import {GET_ONE, refreshView as refreshViewAction} from "react-admin";
import laravelJsonServerClient from '../../restClient'
import {connect} from 'react-redux';
import {authorized} from '../../authorized'
import swal from "sweetalert";

/**
 * Downloads sales channel products and refreshes inventory priority routing records.
 */
class SyncPriorityBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };

        this.handleClick = this.handleClick.bind(this);
    };

    handleClick() {
        if (this.state.loading) {
            return;
        }

        const channelId = this.props.filterValues && this.props.filterValues.channel_id;
        const confirmText = channelId
            ? 'This will download products for the selected channel and update routing records. Stale records may be removed.'
            : 'This will download products for every routing channel and update routing records. Stale records may be removed.';

        swal(confirmText, {
            title: 'SYNC INVENTORY PRIORITY',
            buttons: {
                cancel: "Cancel",
                ok: {
                    text: "Sync",
                    value: "sync",
                }
            },
        }).then(value => {
            if (value !== "sync") {
                return;
            }
            this.runSync(channelId);
        });
    }

    runSync(channelId) {
        this.setState({loading: true});

        let resource = 'inventory/priority/sync';
        if (channelId) {
            resource += '?channel_id=' + channelId;
        }

        laravelJsonServerClient(GET_ONE, resource, null).then(
            r => {
                this.setState({loading: false});
                if (r.data && r.data.result) {
                    const stats = r.data.stats || {};
                    swal(
                        'Channels: ' + (stats.channels || 0)
                        + '\nProducts: ' + (stats.products || 0)
                        + '\nCreated: ' + (stats.created || 0)
                        + '\nMatched: ' + (stats.matched || 0)
                        + '\nUnmatched: ' + (stats.unmatched || 0)
                        + '\nRemoved: ' + (stats.removed || 0),
                        {title: 'SYNC COMPLETE'}
                    );
                    this.props.refreshView();
                } else {
                    swal((r.data && r.data.message) || 'Inventory priority sync failed', {title: 'NOTIFY'});
                }
            }
        ).catch((e) => {
            this.setState({loading: false});
            swal(e.message || 'Inventory priority sync failed', {title: 'NOTIFY'});
            console.error(e);
        });
    }

    render() {
        if (authorized.permissions.indexOf('inventory.priority.list') === -1) {
            return (<span/>);
        }

        return (
            <Button
                label="Sync"
                size="small"
                color="primary"
                variant="outlined"
                disabled={this.state.loading}
                onClick={this.handleClick}
                startIcon={this.state.loading ? <CircularProgress size={15} color={'inherit'}/> : <SyncIcon/>}
            >
                Sync
            </Button>
        );
    }
}

export default connect(undefined, {refreshView: refreshViewAction})(
    SyncPriorityBtn
);
